import { observeMediaElement } from "./mediaTelemetry";

// Logo video: paused on its first frame, plays once on hover,
// with a brief mid-playback hold at a fixed timecode.
export function initLogoVideo(logo) {
  if (!logo) return;

  // Already on the page the logo links to: don't reload/replay the intro.
  logo.addEventListener("click", (e) => {
    // Compare the query too: search results live at "/?s=...", same path as home.
    const url = new URL(logo.href);
    if (url.pathname === window.location.pathname && url.search === window.location.search) {
      e.preventDefault();
    }
  });

  const v = logo.querySelector("video");
  if (!v) return;

  observeMediaElement(v, { context: "logo-video", kind: "nav", src: v.currentSrc || v.src });

  const HOLD_AT = 1.2; // seconds into the video where playback should pause
  const HOLD_DURATION = 500; // ms to hold before resuming

  v.playbackRate = 1.5;
  v.loop = false;
  v.pause();
  try { v.currentTime = 0; } catch (e) {}

  // Some browsers won't paint a frame until playback starts: nudge it.
  const paintFirstFrame = () => {
    const playPromise = v.play();
    if (playPromise && typeof playPromise.then === "function") {
      playPromise.then(() => {
        v.pause();
        try { v.currentTime = 0; } catch (e) {}
      }).catch(() => {});
    } else {
      v.pause();
      try { v.currentTime = 0; } catch (e) {}
    }
  };
  if (v.readyState >= 2) paintFirstFrame();
  else v.addEventListener("loadeddata", paintFirstFrame, { once: true });

  let holdTimer = null;
  let holdTriggered = false;
  v.addEventListener("timeupdate", () => {
    if (holdTriggered || v.currentTime < HOLD_AT) return;
    holdTriggered = true;
    v.pause();
    holdTimer = setTimeout(() => {
      v.play().catch(() => {});
    }, HOLD_DURATION);
  });

  logo.addEventListener("mouseenter", () => {
    if (!v.paused && !v.ended) return;
    if (holdTimer) {
      clearTimeout(holdTimer);
      holdTimer = null;
    }
    holdTriggered = false;
    try { v.currentTime = 0; } catch (e) {}
    v.play().catch(() => {});
  });
}
